module.exports = __webpack_public_path__ + "static/media/rafal.8bff496f.jpg";